export const NUM_REMAINDER_TOO_LOW = 479;
export const PRODUCT_TECH_MAP_LINKED_ERROR = 494;
export const ASSEMBLY_TECH_MAP_LINKED_ERROR = 485;
export const PREFORM_TECH_MAP_LINKED_ERROR = 488;
export const TECH_PROCESS_ALREADY_STARTED_ERROR = 495;
